import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useParams } from "react-router-dom";

export const useShowID = () => useParams().showID;

export const useShow = (accountID, showID) => {
    const queryClient = useQueryClient();
    return useQuery({
        queryKey: ["show", accountID, showID],
        queryFn: () => axios.get(`/api/${accountID}/metrics/shows/${showID}`).then(res => res.data),
        enabled: !!showID
        //placeholderData: () => queryClient.getQueryData(["shows", accountID])?.find(s => s.showID == showID)
    });
};

export const useUpdateShow = (accountID, showID) => {
    const queryClient = useQueryClient();
    return useMutation({
        // HACK: cheat and use the MVC action
        mutationFn: (values) => axios.post(`/__/${ accountID }/podcasts/edit-show/${ showID }`, values).then(res => res.data),
        onSettled: () => {
            queryClient.refetchQueries(["show", accountID, showID]);
        }
    });
}
